import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;

  @media screen and (min-width: 800px) {
    display: none;
  }
`

const MobileView = ( { children, className } ) => ( <Container className={ className }>{children}</Container> )

MobileView.propTypes = {
  'children': PropTypes.oneOfType( [
    PropTypes.arrayOf( PropTypes.node ),
    PropTypes.node
  ] ).isRequired,
  'className': PropTypes.string
}

MobileView.defaultProps = {
  'className': ''
}

export default MobileView
